import { transitionTokens } from '@ardoq/design-tokens';
import type { PopoverPlacement } from '@ardoq/popovers';

export const HOVER_OPEN_DELAY_MS = 400;
export const HOVER_CLOSE_GRACE_MS = 150;

export const PREVIEW_PLACEMENT: PopoverPlacement = {
  side: 'bottom',
  overflow: 'right',
  align: 'anchorEdge',
};

export const CARD_WIDTH = '337px';
export const DESCRIPTION_CLAMP_LINES = 3;
export const SKELETON_TITLE_HEIGHT = '20px';
export const SKELETON_TAG_HEIGHT = '20px';

export const CROSS_FADE_MS = Number.parseFloat(transitionTokens.medium) * 1000;
